import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbsUp } from '@fortawesome/free-solid-svg-icons';

/** Outline/neutral thumb — parent controls click; no local state. */
const UnLikeButtons = ({ size = 16 }) => (
  <span
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '1px',
      color: 'gray',
      fontSize: size,
      lineHeight: 1,
      borderRadius: '8px',
      userSelect: 'none',
      transition: 'color 0.2s ease',
    }}
  >
    <FontAwesomeIcon icon={faThumbsUp} />
  </span>
);

export default UnLikeButtons;
